<script>
	import ContactCard from './ContactCard.svelte';

	let name = '';
	$: description = '';
	$: jobTitle = '';
	$: profileImage = ''

	// $: = Reactive variable
	$: uppercaseName = name.toUpperCase();
	$: console.log(name);

	function setImage() {
		profileImage = 'https://www.jondjones.com/images/background/jondjones_search.png';
	}

	function changeName() {
		name = 'Amo';
	}

	function nameInput(e) {
		name = e.target.value;
		console.log(name);
	}
</script>

<style>
	h1 {
		color: purple;
	}

	.container {
		padding: 1rem;
	}
</style>

<h1>Hello {uppercaseName}</h1>

<div class="container">
	<!-- Two-way Binding -->
	<input type="text" value={name} on:input={nameInput}  placeholder="Username"/>

	<!-- Shortcut Two-way binding syntax -->
	<input type="text" bind:value={jobTitle} placeholder="Job Title"/>

	<input type="text" bind:value={profileImage} placeholder="Job Title"/>
	<textarea  rows="3" bind:value={description} placeholder="Description"/>
</div>
<div class="container">
	<button on:click="{setImage}">Set Profile Image</button>
	<button on:click="{changeName}">Change Name</button>
</div>

<ContactCard 
	userName={name} 
	{jobTitle} 
	{description} 
	{profileImage} />